export default function () {
  return [
    { valueOfMatter: 0, fee: 0 },
    { valueOfMatter: 500, fee: 49 },
    { valueOfMatter: 1000, fee: 88 },
    { valueOfMatter: 1500, fee: 127 },
    { valueOfMatter: 2000, fee: 166 },
    { valueOfMatter: 3000, fee: 222 },
    { valueOfMatter: 4000, fee: 278 },
    { valueOfMatter: 5000, fee: 334 },
    { valueOfMatter: 6000, fee: 390 },
    { valueOfMatter: 7000, fee: 446 },
    { valueOfMatter: 8000, fee: 502 },
    { valueOfMatter: 9000, fee: 558 },
    { valueOfMatter: 10000, fee: 614 },
    { valueOfMatter: 13000, fee: 666 },
    { valueOfMatter: 16000, fee: 718 },
    { valueOfMatter: 19000, fee: 770 },
    { valueOfMatter: 22000, fee: 822 },
    { valueOfMatter: 25000, fee: 874 },
    { valueOfMatter: 30000, fee: 955 },
    { valueOfMatter: 35000, fee: 1036 },
    { valueOfMatter: 40000, fee: 1117 },
    { valueOfMatter: 45000, fee: 1198 },
    { valueOfMatter: 50000, fee: 1279 },
    { valueOfMatter: 65000, fee: 1373 },
    { valueOfMatter: 80000, fee: 1467 },
    { valueOfMatter: 95000, fee: 1561 },
    { valueOfMatter: 110000, fee: 1665 },
    { valueOfMatter: 125000, fee: 1749 },
    { valueOfMatter: 140000, fee: 1843 },
    { valueOfMatter: 155000, fee: 1937 },
    { valueOfMatter: 170000, fee: 2031 },
    { valueOfMatter: 185000, fee: 2125 },
    { valueOfMatter: 200000, fee: 2219 },
    { valueOfMatter: 230000, fee: 2351 },
    { valueOfMatter: 260000, fee: 2483 },
    { valueOfMatter: 290000, fee: 2615 },
    { valueOfMatter: 320000, fee: 2747 },
    { valueOfMatter: 350000, fee: 2879 },
    { valueOfMatter: 380000, fee: 3011 },
    { valueOfMatter: 410000, fee: 3143 },
    { valueOfMatter: 440000, fee: 3275 },
    { valueOfMatter: 470000, fee: 3407 },
    { valueOfMatter: 500000, fee: 3539 },
  ];
}
5


// WEBPACK FOOTER //
// ./src/reducers/feeTable.js